import { render, staticRenderFns } from "./ConsultingSettingsForm.vue?vue&type=template&id=1f0f038a&scoped=true"
import script from "./ConsultingSettingsForm.vue?vue&type=script&lang=js"
export * from "./ConsultingSettingsForm.vue?vue&type=script&lang=js"
import style0 from "./ConsultingSettingsForm.vue?vue&type=style&index=0&id=1f0f038a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f038a",
  null
  
)

export default component.exports